import React, { Suspense, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import RouterConfig from './routes/RouterConfig';
import { ConfigProvider, Spin } from 'antd';
import styled from 'styled-components';
import koKR from 'antd/lib/locale/ko_KR';
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { CommonProvider } from 'hooks/CommonContext';
dayjs.locale("ko");

const SpinWrapper = styled.div`
  min-height: 100vh;
  max-height: calc(100vh + 300px);
  background-color: #dee0e0;
`;

const App = () => {
  const [common, setCommon] = useState({});

  return (
    <ConfigProvider 
      locale={koKR} 
      theme={{
          components: {
            Layout: {
            bodyBg : '#dee0e0'
            },
          },
        }}>
      <Suspense
        fallback={
          <SpinWrapper>
            <Spin />
          </SpinWrapper>
        }
        >
        <SpinWrapper>
          <BrowserRouter>
            <CommonProvider>
              <RouterConfig common={common} setCommon={setCommon} />
            </CommonProvider>
          </BrowserRouter>
        </SpinWrapper>
      </Suspense>
    </ConfigProvider>
  );
};

export default App;
